import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledChatbotAim = styled.svg<IconProps>`
  & .cls-1,
  & .cls-3 {
    fill: var(--chatbot-color-primary, #404040);
  }

  & .cls-1 {
    stroke: var(--du-color-white, #fff);
  }

  & .cls-2 {
    fill: none;
  }
`;

const ChatbotAimIcon: React.FC<IconProps> = props => {
  const activeclass = props.active ? 'active' : undefined;
  return (
    <StyledChatbotAim
      id='Chatbot-Aim-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='Aim' transform='translate(-56 -8)'>
        <path
          id='_3d620d703827c64848ee550bbc521556'
          data-name='3d620d703827c64848ee550bbc521556'
          className='cls-1'
          d='M24.939,12.866H23.647A9.659,9.659,0,0,0,15.281,4.5V3.207a1.207,1.207,0,1,0-2.415,0V4.5A9.659,9.659,0,0,0,4.5,12.866H3.207a1.207,1.207,0,1,0,0,2.415H4.5a9.659,9.659,0,0,0,8.367,8.367v1.292a1.207,1.207,0,1,0,2.415,0V23.647a9.659,9.659,0,0,0,8.367-8.367h1.292a1.207,1.207,0,1,0,0-2.415ZM20.11,15.281h1.1a7.244,7.244,0,0,1-5.928,5.928v-1.1a1.207,1.207,0,1,0-2.415,0v1.1a7.244,7.244,0,0,1-5.928-5.928h1.1a1.207,1.207,0,1,0,0-2.415h-1.1a7.244,7.244,0,0,1,5.928-5.928v1.1a1.207,1.207,0,0,0,2.415,0v-1.1a7.244,7.244,0,0,1,5.928,5.928h-1.1a1.207,1.207,0,1,0,0,2.415Zm-6.037-2.415a1.207,1.207,0,1,0,1.207,1.207A1.207,1.207,0,0,0,14.073,12.866Z'
          transform='translate(58.427 10.427)'
        />
        <rect
          id='Rectangle_7275'
          data-name='Rectangle 7275'
          className='cls-2'
          width='32'
          height='32'
          transform='translate(56 8)'
        />
        <circle
          id='Ellipse_247782'
          data-name='Ellipse 247782'
          className='cls-3'
          cx='1.75'
          cy='1.75'
          r='1.75'
          transform='translate(70.75 23)'
        />
      </g>
    </StyledChatbotAim>
  );
};

export default ChatbotAimIcon;
